﻿angular.module('taric.quota', [])
    .config(['$routeProvider', routeConfigurator])
    .component('ordernumberButton', require('./components/ordernumber-button'))
    .component('ukOrdernumberButton', require('./components/uk-ordernumber-button'))
    .component('orderNumberPicker', require('./components/order-number-picker'))
    .component('quotaSearchPage', require('./components/quota-search-page'))
    .component('quotaForm', require('./components/quota-form'))
    .component('quotaTable', require('./components/quota-table'))
    .filter('orderNumberTypeahead', require('./filters/order-number-typeahead-filter'))
    .factory('orderQuotaModal', require('./modals/order-quota'))
    .factory('ukOrderQuotaModal', require('./modals/uk-order-quota'))
    .factory('quotaModals', require('./modals/modals'))
    .factory('quotaDataService', require('./services/quota-data'))
    ;

    function routeConfigurator($routeProvider) {
        $routeProvider
            .when('/quota/search', {
                template: '<quota-search-page></quotar-search-page>'
            })
        ;
    }